import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { UserMinus, UserPlus } from 'react-feather';
import useTranslation from 'next-translate/useTranslation';
import { useFollow, useAuthentication } from '../../../../api';
import AuthenticationPopupDialog from '../../../Modals/AuthenticationPopupDialog';
import CentralizeButton from '../../../../VuexyDesign/atoms/CentralizeButton';

export const FollowButton = styled(
  ({
    userId,
    disabled,
    buttonColor,
  }: {
    userId: number;
    disabled?: boolean;
    className?: string;
    buttonColor?:
      | 'primary'
      | 'secondary'
      | 'dark'
      | 'success'
      | 'error'
      | 'warning'
      | 'info'
      | 'gradient';
  }) => {
    const { toggle, following, follower, loading } = useFollow(userId);
    const { isLoggedIn } = useAuthentication();
    const [
      isAuthenticationDialogOpen,
      setIsAuthenticationDialogOpen,
    ] = useState(false);
    const { t } = useTranslation('profile');
    const children = useMemo(() => {
      // if (!following && follower) {
      //   return 'Follow back';
      // }

      const result = following ? t('profile:following') : t('profile:follow');

      return result;
    }, [following, follower]);

    const handleAuthenticationDialogClose = () => {
      setIsAuthenticationDialogOpen(false);
    };
    const handleAuthenticationDialogOpen = () => {
      setIsAuthenticationDialogOpen(true);
    };

    const onClick = () => {
      if (isLoggedIn) {
        toggle();
      } else {
        handleAuthenticationDialogOpen();
      }
    };

    return (
      <>
        <AuthenticationPopupDialog
          isOpen={isAuthenticationDialogOpen}
          onClose={handleAuthenticationDialogClose}
        />
        {following ? (
          <CentralizeButton
            active={following}
            color="dark"
            size="sm"
            text={children}
            disabled={disabled || loading}
            icon={UserMinus}
            isIconLeftSide
            onClick={onClick}
            outline
          />
        ) : (
          <div>
            <CentralizeButton
              active={following}
              color={buttonColor || 'secondary'}
              size="sm"
              text={children}
              disabled={disabled || loading}
              icon={UserPlus}
              isIconLeftSide
              onClick={onClick}
            />
          </div>
        )}
      </>
    );
  },
)``;
